<template>
  <li
    class="search-results__item card__item flex-basis-25 add-large-top-padding"
  >
    <div
      class="search-results__item--image add-bottom-margin"
      v-if="hasImage(result)"
    >
      <button
        class="btn btn--black btn--tertiary type-small quick-view js-show-quick-view"
        @click="toggleModal(result.Id)"
      >
        Quick View
      </button>
      <a :href="href(result)">
        <img :src="imageUrl(result)" class="full-cover" :alt="result.Name" />
      </a>
    </div>
    <div
      class="search-results__item--cover add-bottom-margin"
      v-if="!hasImage(result)"
    >
      <button
        class="btn btn--black btn--tertiary type-small quick-view js-show-quick-view"
        @click="toggleModal(result.Id)"
      >
        Quick View
      </button>
      <a :href="href(result)">
        <div
          class="search-results__item--cover-contents color-black flex flex--column flex--between"
          :class="customColor(result)"
        >
          <div>
            <div
              class="image-monogram-secondary-white add-bottom-margin align-l"
            >
              <img
                src="/images/concord-monogram.svg?v2"
                width="32"
                height="32"
                alt=""
              />
            </div>
            <h3
              class="type-h3 no-bottom-margin"
            >
              {{ result.Name | truncate(55) }}
            </h3>
          </div>
          <p
            class="card-authors type-regular type-circular-italic no-bottom-margin"
            v-if="result.Authors.length > 0"
          >
            <span
              class="type-regular type-circular display-inline"
              v-if="result.Authors.length <= 2"
              v-for="(name, index) in result.Authors"
            >
              {{ name.FirstName }} {{ name.LastName
              }}<span v-if="index !== result.Authors.length - 1">, </span>
            </span>
            <span
              class="type-regular type-circular display-inline"
              v-else-if="result.Authors.length > 2 && index === 0"
            >
              Multiple Authors
            </span>
          </p>
        </div>
      </a>
    </div>
    <div class="search-results__item--text">
      <div>
        <a class="search-results__item-link color-black" :href="href(result)">
          <h5 class="type-h5 add-x-small-bottom-margin">
            {{ result.Name | truncate(66) }}
          </h5>
        </a>
        <p
          class="type-small no-bottom-margin color-silver-dark"
          v-if="result.Authors.length > 0"
        >
          <span
            v-if="result.Authors.length <= 2"
            v-for="(name, index) in result.Authors"
          >
            {{ name.FirstName }} {{ name.LastName
            }}<span v-if="index !== result.Authors.length - 1">, </span>
          </span>
          <span v-else-if="result.Authors.length > 2 && index === 0">
            Multiple Authors
          </span>
        </p>
        <p class="type-small no-bottom-margin color-silver-dark type-italic">
          {{ result.TitleTypeOfPlayAndGenre }} <br />
          {{ result.TitleCasting }}
        </p>
      </div>
    </div>
    <div class="modal quick-view-modal" v-if="modalOpen">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div
          class="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-1-title"
          :aria-describedby="'modal-' + result.Id"
        >
          <div role="document">
            <header class="modal__header">
              <button
                class="modal__close"
                aria-label="Close modal"
                @click="toggleModal"
                aria-controls="modal__container1"
              ></button>
            </header>
            <main
              class="modal__content flex add-large-bottom-padding"
              :id="'modal-' + result.Id"
            >
              <QuickViewModal
                :product="result.Id"
                :catalog="'perform'"
              ></QuickViewModal>
            </main>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import QuickViewModal from './QuickViewModal.vue';
import AddToWishlist from './AddToWishlist.vue';

export default {
  name: 'GlobalSearchPerformResults',
  props: ['result'],
  components: {
    QuickViewModal,
    AddToWishlist,
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  methods: {
    hasImage(result) {
      const image = result.ProductImages.find((img) => img.Type === 'Perform');
      return typeof image !== 'undefined' ? true : false;
    },

    imageUrl(result) {
      const image = result.ProductImages.find((img) => img.Type === 'Perform');
      return image.ImageUrl;
    },

    customColor(result) {
      let color =
        result.FeaturedColor !== null && result.FeaturedColor !== ''
          ? result.FeaturedColor
          : 'red-tint';
      switch (color) {
        case 'purple':
          color = 'sky-blue';
          break;
        case 'navy':
          color = 'red-tint';
          break;
        case 'purple-light':
          color = 'orange-tint';
          break;
        case 'blue':
          color = 'sky-blue-tint';
          break;
      }
      return `bg-color-${color}`;
    },

    href(product, retail = false) {
      let path = 'p';
      if (retail) {
        path = 's';
      }
      return `/${path}/${product.Id}/${product.SeName}`;
    },

    getAuthorHref(author) {
      return `/a/${author.Id}/${author.SeName}`;
    },

    toggleModal(id) {
      this.modalOpen = !this.modalOpen;
    },

    licenseRequestPath(product) {
      return `${window.env.ZOHRAB_LICENSE_DOMAIN}/performance-license/license?productId=${product.Id}`;
    },

    // from https://laracasts.com/discuss/channels/general-discussion/escape-html-characters-with-vuejs
    decodeHtmlEntities(str) {
      var txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    },
  },
  filters: {
    truncate(string, value) {
      if (string.length > value) {
        return `${string.substring(0, value)}...`;
      } else {
        return string;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GlobalSearchPerformResults.vue